import { AUTH_ERROR_KEY, AUTH_RETURN_KEY } from '../utils/auth'

/* Client-only guard mirroring apps/admin's Auth0 route guard (WFL-7541):
   the auth pages themselves are exempt by route name, an Auth0 `?error=`
   is sent to /auth/status, `meta.public` routes are skipped, then the
   settled Auth0 session gates everything else. */
export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server) return

  if (to.name === 'auth-login' || to.name === 'auth-callback') {
    return
  }

  if (to.query.error) {
    if (to.name === 'auth-status') return
    localStorage.setItem(AUTH_ERROR_KEY, JSON.stringify(to.query))
    return navigateTo('/auth/status', { replace: true })
  }

  if (to.meta.public) {
    return
  }

  const { $auth0, $auth0Ready } = useNuxtApp()
  await $auth0Ready()

  if ($auth0().isAuthenticated.value) {
    const intendedUrl = localStorage.getItem(AUTH_RETURN_KEY)
    if (intendedUrl) {
      localStorage.removeItem(AUTH_RETURN_KEY)
      return navigateTo(intendedUrl)
    }
    return
  }

  localStorage.setItem(AUTH_RETURN_KEY, to.fullPath)
  return navigateTo('/auth/login')
})
